import React, {useState} from "react";

import "../../scss/form.scss";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPlus} from "@fortawesome/free-solid-svg-icons";
import Modal from "../Modal";
import API from "../../api";
import Status from "../Status";
import {SubForm, SubFormTable} from "../Form";
import {addListItem, removeListItem} from "./functions";

const OpenList = props => {
    const [show, setShow] = useState(false);
    const [error, setError] = useState(null);
    const [form, setForm] = useState(null);
    const [state, setState] = useState(props);

    const handleOpen = async () => {
        const {success, error, forms} = await API.forms.find({title: props.form, raw: true});

        if(success) setForm(forms[0]);
        else setError(error);

        setShow(true);
    }

    // `next`, not `state`: `setState` does not change the `state` this render
    // closed over, so reporting `state` sent the list as it was *before* the
    // edit. And `{items}` alone would drop the field's `uid`, `type` and
    // `label` — see `addListItem`.
    const addItem = item => {
        const next = addListItem(state, item);

        setState(next);
        setShow(false);

        props.onChange(next);
    }

    const removeItem = index => {
        const next = removeListItem(state, index);

        setState(next);

        props.onChange(next);
    }

    const inherit = {...props};
    delete inherit.onChange;

    return (<div actionkey={props.actionkey}>
        {state.items && (<>
            <div style={{position: "relative"}} onClick={() => handleOpen()}>
                <div {...inherit} className="form-open-list" variant="white">Add to List</div>
                <FontAwesomeIcon icon={faPlus}/>
            </div>
            {(state.items.length > 0) ? 
            <SubFormTable 
                items={state.items} 
                onRemove={tr => removeItem(tr)}/> :
            <Status.Switch data={state.items}/>}
            <Modal show={show} onClose={() => setShow(false)}>
                {form ? 
                <SubForm form={form} onSubmit={item => addItem(item)}/> :
                <Status loading/>}
            </Modal>
        </>)}
        <Status error>{error}</Status>
    </div>);
}

export default OpenList;